<template>
  <v-container>
    <v-layout align-center justify-end>
      <div class="item">
        <v-switch
          @change="filterFavorites"
          v-model="onlyFavorites"
          :label="$t('calendar.OnlyFavorites')"
        ></v-switch>
      </div>
      <div class="item ml-4">
        <v-btn color="success" @click="createEvent">
          <v-icon left>add</v-icon>
          <span>{{$t('calendar.CreateEvent')}}</span>
        </v-btn>
      </div>
    </v-layout>
    <v-layout>
      <v-flex>
        <v-sheet height="450">
          <v-calendar v-model="start" ref="calendar" :now="today" :value="today" color="primary">
            <template v-slot:day="{ date }">
              <div v-for="event in eventsMap[date]" :key="event.id">
                <v-menu :key="event.title" v-model="event.open" full-width offset-x>
                  <template v-slot:activator="{ on }">
                    <div
                      v-if="!event.time"
                      v-ripple
                      class="my-event"
                      v-on="on"
                      v-html="event.title"
                    />
                  </template>
                  <v-card color="grey lighten-4" min-width="350px" flat>
                    <v-toolbar color="primary" dark>
                      <v-btn v-if="canEditEvent(event)" @click="editEvent(event)" icon>
                        <v-icon>edit</v-icon>
                      </v-btn>
                      <v-toolbar-title v-html="event.title" />
                      <v-spacer />
                      <v-btn v-if="canEditEvent(event)" icon @click="addToFavorites(event)">
                        <v-icon v-bind:color="event.isFavorite? 'red': ''">favorite</v-icon>
                      </v-btn>
                      <v-btn v-if="canLinkEvent(event)" @click="linkCourse(event)" icon>
                        <v-icon>add</v-icon>
                      </v-btn>
                      <v-btn v-if="canEditEvent(event)" @click="onDeleteEvent(event)" icon>
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card-text>
                      <div v-if="event.link" class="mt-2">
                        <v-icon class="mr-1" color="primary">turned_in</v-icon>
                        <a target="_blank" v-bind:href="event.link">{{event.link}}</a>
                      </div>
                      <div v-if="event.fromHour && event.toHour" class="mt-2">
                        <v-icon class="mr-1" color="primary">schedule</v-icon>
                        {{event.fromHour}} - {{event.toHour}}
                      </div>
                      <div class="mt-2">
                        <v-icon class="mr-1" color="primary">place</v-icon>
                        {{event.local}}
                      </div>
                      <div class="mt-2">{{event.resume}}</div>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn flat color="secondary">{{$t('common.Cancel')}}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </div>
            </template>
          </v-calendar>
        </v-sheet>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 class="text-sm-left text-xs-center">
        <v-btn @click="$refs.calendar.prev()">
          <v-icon left>keyboard_arrow_left</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12 class="text-sm-right text-xs-center">
        <v-btn @click="$refs.calendar.next()">
          <v-icon right>keyboard_arrow_right</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-dialog :persistent="true" v-model="dialog" max-width="600" lazy>
      <add-event-form :form-data="selectedEntry" :close-me="() => dialog = false" />
    </v-dialog>
    <v-dialog :persistent="true" v-model="courseDialog" max-width="600" lazy>
      <AddCourseForm
        :is-linking="true"
        :form-data="newCourse"
        :close-me="() => courseDialog = false"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import AddEventForm from "@/views/Calendar/AddEventForm";
import AddCourseForm from "@/views/Course/AddCourseForm";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    AddEventForm,
    'AddCourseForm': AddCourseForm
  },
  /* eslint-disable */
  data: () => {
    let today = new Date();

    return {
      newCourse: null,
      courseDialog: false,
      start: `${today.getFullYear()}-${today.getMonth() + 1}-01`,
      selectedEntry: null,
      dialog: false,
      onlyFavorites: false,
      today: `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`
    };
  },
  computed: {
    ...mapGetters(["events", "user"]),
    // convert the list of events into a map of lists keyed by date
    eventsMap() {
      const map = {};
      this.eventsFiltered.forEach(e =>
        (map[e.date] = map[e.date] || []).push(e)
      );
      return map;
    },
    eventsFiltered() {
      if (this.$route.query && this.$route.query.onlyFavorites) {
        return [...this.events.filter(e => e.isFavorite)];
      } else {
        return [...this.events];
      }
    },
    userIsNationalAdmin() {
      return this.user && (this.user.roles || []).includes("national-admin");
    }
  },
  created() {
    this.getEvents({
      userId: this.$store.getters.profile.id,
      specialty: this.user.specialty
    });
  },
  methods: {
    ...mapActions([
      "getEvents",
      "addEvent",
      "deleteEvent",
      "showSuccessSnackbar",
      "addEventToFavorites"
    ]),
    canEditEvent(event) {
      return (
        event.userId === this.$store.getters.profile.id ||
        (this.userIsNationalAdmin &&
          this.user.specialty === event.nationalAdminEventOf)
      );
    },
    canLinkEvent(event) {
      return !this.userIsNationalAdmin;
    },
    linkCourse(event) {
      this.newCourse = {
        type: event.type,
        where: event.where,
        title: event.title,
        date: event.date,
        local: event.local,
        organizer: event.organizer,
        linkedCourse: event.id
      };

      this.courseDialog = true;
    },
    addToFavorites(event) {
      this.addEventToFavorites(event);
    },
    filterFavorites() {
      let query = {};

      if (this.onlyFavorites) {
        query.onlyFavorites = true;
      }

      this.$router.push({
        name: "Calendar",
        query: query
      });
    },
    editEvent(event) {
      this.selectedEntry = event;
      this.dialog = true;
    },
    createEvent() {
      this.selectedEntry = {};
      this.dialog = true;
    },
    onDeleteEvent(event) {
      this.deleteEvent(event).then(() => {
        this.showSuccessSnackbar(this.$t("calendar.EventDeleted"));
      });
    }
  }
};
</script>

<style>
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
}
</style>
